// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1ju2f","head":"ProcedureTableInfo_head__7oWup"};